// Modules
import React, { useContext, useState } from "react";
import SwiperCore, {
  Navigation,
  // Pagination,
  Autoplay,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from "@material-ui/lab/Skeleton";
import PropTypes from "prop-types";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
// import Divider from "../utils/Divider";
import ShareButtons from "../utils/ShareButtons";

// Assets
import "./carousel.scss";
import CloseIcon from "../../assets/img/svg/Close_icon.jsx";

// install Swiper modules
SwiperCore.use([Navigation/*, Pagination,*/, Autoplay]);

const Carousel = (props) => {
  const {
    loader,
    data,
    idFiche,
    rooms,
    imagesNeighborhoodArr,
  } = props;
  const {
    photo_interieur_toilettes,
    photo_copro,
    photo_facade,
    photo_agglo,
    descriptif_bien_2,
    descriptif_bien_3,
    m2_carrez,
    ville,
    quartier,
    est_termine,
  } = data;
  // let est_termine = true;
  const virtualTour = data["visite virtuelle"];
  const contentIframe = (
    <iframe
      title="view-3d"
      width="100%"
      height="100%"
      className="iframe-matterport"
      src={virtualTour}
      frameBorder="0"
      allowFullScreen
    />
  );
  const slides = rooms.length > 0 && (est_termine === false || est_termine === undefined)
    ? [
      ...rooms.map((room, idx) => idx <= 1 ? room.img : null),
      contentIframe,
      ...rooms.map((room, idx) => idx >= 2 ? room.img : null),
      photo_interieur_toilettes,
      photo_copro,
      photo_facade,
      photo_agglo,
      ...imagesNeighborhoodArr,
      ...rooms.map((room) => room.imgBack !== null && room.img !== null ? room.imgBack : null),
    ] : rooms.length > 0 && est_termine === true
      ? [
        ...rooms.map((room) => room.imgBack),
        photo_copro,
        photo_facade,
        photo_agglo,
        ...imagesNeighborhoodArr,
      ] : [
        contentIframe,
        photo_interieur_toilettes,
        photo_copro,
        photo_facade,
        photo_agglo,
        ...imagesNeighborhoodArr,
      ];
  const slidesLegends = rooms.length > 0 && (est_termine === false || est_termine === undefined)
    ? [
      ...rooms.map((room, idx) => idx <= 1 ? room.label : null),
      "Vue 3D du bien",
      ...rooms.map((room, idx) => idx >= 2 ? room.label : null),
      "Toilettes",
      "Parties communes",
      "Façade",
      `${ville}`,
      ...imagesNeighborhoodArr.map(() => `${quartier}`),
      ...rooms.map((room) => room.imgBack !== null && room.img !== null ? `${room.label} - Exemple après travaux` : null),
    ] : rooms.length > 0 && est_termine === true
      ? [
        ...rooms.map((room) => `${room.label} après travaux`),
        "Parties communes",
        "Façade",
        `${ville}`,
        ...imagesNeighborhoodArr.map(() => `${quartier}`),
      ] : [
        "Vue 3D du bien",
        "Toilettes",
        "Parties communes",
        "Façade",
        `${ville}`,
        ...imagesNeighborhoodArr.map(() => `${quartier}`),
      ];
  const opportunityTitle = `${descriptif_bien_2} de ${m2_carrez}m², ${descriptif_bien_3} à ${ville}`;
  const { isMobile, isTablet } = useContext(ApiContext);
  const [isOpenFullscreen, setIsOpenFullscreen] = useState(false);

  return (
    <div className={`caroussel-container ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
      {/* <Divider text="Informations clés" loader={loader} clssName="divider-carousel" /> */}
      {isOpenFullscreen === true
        ? (
          <div className="full-screen-swiper-container">
            <div className="background-modal" onClick={() => setIsOpenFullscreen(false)} />
            <div className={`modal-content ${isOpenFullscreen === true ? "opened" : "closed"}`}>
              {/* <FullscreenExitIcon className="fullscreen-icon" onClick={() => setIsOpenFullscreen(false)} /> */}
              <CloseIcon clssName="close-icon" onClick={() => setIsOpenFullscreen(false)} />
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                navigation
                pagination={false}/*{{ clickable: true }}*/
              >
                {loader
                  /* /!\ Numérotation ? */
                  ? [1, 2, 3, 4, 6].map((slide, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <Skeleton variant="rect" width="100%" height="100%" />
                      </SwiperSlide>
                    );
                  })
                  : slides.map((slide, index) => {
                    if (virtualTour && slide !== null) {
                      if (contentIframe === slide)
                        return (
                          <SwiperSlide key={index}>
                            <h6 className="legend">{slidesLegends[index]}</h6>
                            {contentIframe}
                          </SwiperSlide>
                        );
                      else
                        return (
                          <SwiperSlide key={index}>
                            <h6 className="legend">{slidesLegends[index]}</h6>
                            <div
                              className="image-carousel"
                              style={{ backgroundImage: `url(${slide})` }}
                            />
                          </SwiperSlide>
                        );
                    }
                    else if (slide !== null) {
                      if (contentIframe === slide)
                        return null;
                      else
                        return (
                          <SwiperSlide key={index}>
                            <h6 className="legend">{slidesLegends[index]}</h6>
                            <div
                              className="image-carousel"
                              style={{ backgroundImage: `url(${slide})` }}
                            />
                          </SwiperSlide>
                        );
                    }
                    else
                      return null;
                  })}
              </Swiper>
            </div>
          </div>
        ) : null}
      <Swiper
        spaceBetween={0}
        slidesPerView={isMobile === true || isTablet === true ? 1 : 2}
        navigation
        pagination={false}/*{{ clickable: true }}*/
      >
        <svg className="fullscreen-icon" viewBox="0 0 24 24" onClick={() => setIsOpenFullscreen(true)} >
          <path
            d="M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z"
            stroke="#0A313E"
            strokeWidth="0.5"
          />
        </svg>
        {loader
          /* /!\ Numérotation ? */
          ? [1, 2, 3, 4, 6].map((slide, index) => {
            return (
              <SwiperSlide key={index}>
                <Skeleton variant="rect" width="100%" height="100%" />
              </SwiperSlide>
            );
          })
          : slides.map((slide, index) => {
            if (virtualTour && slide !== null) {
              if (contentIframe === slide)
                return (
                  <SwiperSlide key={index}>
                    {contentIframe}
                  </SwiperSlide>
                );
              else
                return (
                  <SwiperSlide key={index}>
                    <div
                      className="image-carousel"
                      style={{ backgroundImage: `url(${slide})` }}
                    />
                  </SwiperSlide>
                );
            }
            else if (slide !== null) {
              if (contentIframe === slide)
                return null;
              else
                return (
                  <SwiperSlide key={index}>
                    <div
                      className="image-carousel"
                      style={{ backgroundImage: `url(${slide})` }}
                    />
                  </SwiperSlide>
                );
            }
            else
              return null;
          })}
      </Swiper>
      <div className="row-container">
        {loader
          ? (
            <Skeleton
              variant="text"
              width="35%"
              height="8vh"
              className="opportunity-title"
            />
          ) : <h3 className="opportunity-title">{opportunityTitle}</h3>}
        <ShareButtons
          loading={loader}
          title={opportunityTitle}
          resume={data.resume ?? ""}
          id={idFiche}
          clssName="social-networks-share"
        />
      </div>
    </div>
  );
};

Carousel.propTypes = {
  loader: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  idFiche: PropTypes.string.isRequired,
  rooms: PropTypes.array.isRequired,
  imagesNeighborhoodArr: PropTypes.array.isRequired,
};

export default Carousel;
